<template>
    <div id="ag-grid-demo">
        <vx-card>
            <div class="flex flex-wrap justify-between items-center">
                <div class="mb-4 md:mb-0 mr-4 ag-grid-table-actions-left">
                    <h4 style="margin-left: 10px">Invoice Transporter</h4>
                </div>
                <div
                    class="flex flex-wrap items-center justify-between ag-grid-table-actions-right"
                >
                    <vs-button
                        @click="refreshData"
                        class="btn mb-4 md:mb-0 mr-1"
                        icon="refresh"
                    >Refresh</vs-button>
                    <vs-button
                        :to="{ name: 'invoicetransporter-add'} "
                        class="btn mb-4 md:mb-0 mr-1"
                        icon="add"
                    >Add</vs-button>
                    <vs-button
                        :to="{ name: 'invoicetransporter-view', params: {id: selectedId} }"
                        class="mb-4 md:mb-0 mr-1"
                        icon="remove_red_eye"
                        :disabled="selectedId ? false : true"
                    >View</vs-button>
                    <vs-button
                        class="mb-4 md:mb-0 mr-1"
                        @click="removeItem"
                        icon="delete"
                        :disabled="selectedId ? false : true"
                    >Delete</vs-button>
                    <vs-button
                        class="mb-4 md:mb-0 mr-1"
                        @click="filterActive"
                        icon="filter_list"
                    >Filter</vs-button>
                </div>
            </div>
            <ag-grid-vue
                :gridOptions="gridOptions"
                class="ag-theme-material w-100 my-4 ag-grid-table"
                :columnDefs="columnDefs"
                :defaultColDef="defaultColDef"
                :rowData="dataApi"
                colResizeDefault="shift"
                :animateRows="false"
                :floatingFilter="false"
                rowSelection="single"
                @selection-changed="onSelectionChanged"
                @rowDoubleClicked="viewData"
            ></ag-grid-vue>
            <p class="text-right">
                <b>Showing {{ dataFrom }} to {{ dataTo }} of {{ dataTotal }} total entries</b>
            </p>
            <vs-pagination :total="totalPage" v-model="currentPage" :max="7"></vs-pagination>

            <vs-prompt @accept="filterData" title="Filter" :active.sync="showFilter">
                <div class="con-exemple-prompt">
                    <vs-input
                        placeholder="Client Code"
                        v-model="filter.client"
                        class="mt-4 mb-2 w-full"
                    />
                    <vs-input
                        placeholder="Vehicle Type"
                        v-model="filter.vehicle_type"
                        class="mt-4 mb-2 w-full"
                    />
                    <vs-input
                        placeholder="Contract Type"
                        v-model="filter.contract_type"
                        class="mt-4 mb-4 w-full"
                    />
                    <vs-input
                        placeholder="Origin"
                        v-model="filter.origin"
                        class="mt-4 mb-2 w-full"
                    />
                    <vs-input
                        placeholder="Destination"
                        v-model="filter.destination"
                        class="mt-4 mb-2 w-full"
                    />
                </div>
            </vs-prompt>
        </vx-card>
    </div>
</template>

<script>
import { AgGridVue } from "ag-grid-vue";
import "@/assets/scss/vuesax/extraComponents/agGridStyleOverride.scss";
import vSelect from "vue-select";

export default {
    components: {
        vSelect,
        AgGridVue
    },
    data() {
        return {
            searchQuery: "",
            gridOptions: {},
            maxPageNumbers: 7,
            gridApi: null,
            dataApi: [],
            columnDefs: null,
            defaultColDef: {
                sortable: true,
                editable: false,
                resizable: true,
                suppressMenu: true
            },
            selectedId: null,
            isLoading: false,
            maxRetry: 10,
            showFilter: false,
            filter: {
                client: "",
                vehicle_type: "",
                contract_type: "",
                origin: "",
                destination: ""
            },
            clientTypeOptions: [],
            areaOptions: [],
            // Pagination
            totalPage: 0,
            currentPage: 1,
            dataFrom: 0,
            dataTo: 0,
            dataTotal: 0
        };
    },
    watch: {
        "$store.state.windowWidth"(val) {
            if (val <= 576) {
                this.maxPageNumbers = 4;
                this.gridOptions.columnApi.setColumnPinned("email", null);
            } else this.gridOptions.columnApi.setColumnPinned("email", "left");
        },

        isLoading: function() {
            if (this.isLoading) {
                this.$vs.loading();
            } else {
                this.$vs.loading.close();
            }
        }
    },
    methods: {
        updateSearchQuery(val) {
            this.gridApi.setQuickFilter(val);
        },
        onSelectionChanged() {
            var selectedRows = this.gridApi.getSelectedRows();
            var selectedRowsString = "";
            selectedRows.forEach(function(selectedRow, index) {
                if (index !== 0) {
                    selectedRowsString += ", ";
                }
                selectedRowsString += selectedRow.id;
            });
            this.selectedId = selectedRowsString;
        },
        removeItem() {
            this.$vs.dialog({
                type: "confirm",
                color: "danger",
                title: "Confirm",
                text: "Are you sure want to delete this Invoice Transporter?",
                accept: this.acceptAlert
            });
        },
        acceptAlert() {
            this.isLoading = true;
            this.$http
                .delete("transport/invoicetransporter/" + this.selectedId + "/destroy")
                .then(res => {
                    this.$vs.notify({
                        color: "success",
                        title: "Invoice deleted",
                        iconPack: "feather",
                        icon: "icon-check",
                        text: "The selected invoice was successfully deleted"
                    });
                })
                .catch(error => {
                    this.$vs.notify({
                        title: "Error",
                        text: "Error",
                        color: "danger"
                    });
                })
                .then(() => {
                    this.fetchData();
                });
        },
        refreshData() {
            this.maxRetry = 10;
            this.fetchData();
        },
        fetchData() {
            this.isLoading = true;
            this.maxRetry = this.maxRetry - 1;
            this.$http
                .get("transport/invoicetransporter")
                .then(resp => {
                    this.dataApi = resp.data.data;
                    this.totalPage = resp.data.last_page;
                    this.currentPage = this.currentPage;
                    this.dataTotal = resp.data.total;
                    this.dataFrom = resp.data.from;
                    this.dataTo = resp.data.to;
                    setTimeout(() => {
                        this.isLoading = false;
                    }, 500);
                })
                .catch(resp => {
                    if (this.maxRetry == 0) {
                        this.isLoading = false;
                        this.$vs.dialog({
                            type: "confirm",
                            color: "danger",
                            title: "Server Error",
                            text: "Try again?",
                            accept: () => {
                                this.refreshData();
                            },
                            acceptText: "Yes",
                            cancelText: "No"
                        });
                        return;
                    }
                    this.fetchData();
                });
        },
        viewData() {
            this.$router.push({
                name: "invoicetransporter-view",
                params: {
                    id: this.selectedId
                }
            });
        },
        filterData() {
            this.isLoading = true;
            this.$http
                .post("master/clientrates/filter/search", this.filter)
                .then(resp => {
                    this.dataApi = resp.data;
                    setTimeout(() => {
                        this.isLoading = false;
                    }, 500);
                });
        },
        filterActive() {
            this.filter = {
                name: "",
                client_code: "",
                address_1: "",
                address_2: "",
                area_id: "",
                city: "",
                post_code: "",
                clienttype_id: ""
            };
            this.isLoading = true;
            Promise.all([
                this.$http.get("master/areas/filter/getlist"),
                this.$http.get("master/clienttypes")
            ])
                .then(
                    this.$http.spread((areas, clienttypes) => {
                        this.areaOptions = areas.data;
                        this.clientTypeOptions = clienttypes.data;
                        setTimeout(() => {
                            this.isLoading = false;
                            this.showFilter = true;
                        }, 500);
                    })
                )
                .catch(() => {
                    this.maxRetry = this.maxRetry - 1;
                    if (this.maxRetry < 0) {
                        this.isLoading = false;
                        this.$vs.dialog({
                            type: "confirm",
                            color: "danger",
                            title: "Server Error",
                            text: "Try again?",
                            accept: () => {
                                this.maxRetry = 10;
                                this.filterActive();
                            },
                            acceptText: "Yes",
                            cancelText: "No"
                        });
                        return;
                    }
                    this.filterActive();
                });
        }
    },
    mounted() {
        this.fetchData();
        this.gridApi = this.gridOptions.api;
    },
    beforeMount() {
        this.columnDefs = [
            {
                headerName: "Invoice ID",
                field: "id",
                width: 100,
                filter: true
            },
            {
                headerName: "Reference",
                field: "reference",
                width: 200,
                filter: true
            },
            {
                headerName: "Invoice Date",
                field: "invoice_date",
                filter: true,
                width: 125
            },
            {
                headerName: "Received Date",
                field: "received_date",
                filter: true,
                width: 125
            },
            {
                headerName: "Client ID",
                field: "client.client_code",
                filter: true,
                width: 200
            },
            {
                headerName: "Transporter ID",
                field: "transporter.transporter_code",
                filter: true,
                width: 200
            },
            {
                headerName: "Invoice Amount",
                field: "invoice_amount",
                filter: true,
                width: 200
            },
            {
                headerName: "Contract Type ID",
                field: "contract_type.contract_type",
                filter: true,
                width: 200
            },
            {
                headerName: "Invoice Status",
                field: "id",
                filter: true,
                width: 200
            }
        ];
    }
};
</script>